'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostalCodeElement = exports.IbanElement = exports.CardCVCElement = exports.CardExpiryElement = exports.CardNumberElement = exports.StripeElement = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _LocalizableMessage = require('components/LocalizableMessage/LocalizableMessage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = (0, _reactIntl.defineMessages)({
  fieldRequired: {
    id: 'validators.required',
    defaultMessage: 'This field is required.'
  }
});

var StripeElement = exports.StripeElement = function (_React$PureComponent) {
  (0, _inherits3.default)(StripeElement, _React$PureComponent);

  function StripeElement() {
    var _ref;

    var _temp, _this3, _ret;

    (0, _classCallCheck3.default)(this, StripeElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref = StripeElement.__proto__ || (0, _getPrototypeOf2.default)(StripeElement)).call.apply(_ref, [this].concat(args))), _this3), _this3.state = {
      empty: true,
      complete: false,
      value: ''
    }, _temp), (0, _possibleConstructorReturn3.default)(_this3, _ret);
  }

  (0, _createClass3.default)(StripeElement, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.elements) {
        this.mountedAndElementsAvailable();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.elements && !prevProps.elements) {
        this.mountedAndElementsAvailable();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.element) {
        this.element.destroy();
        this.element = null;
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(event) {
      var onChange = this.props.onChange;


      this.setState(event);

      if (onChange) {
        onChange(event);
      }
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      var _state = this.state,
          empty = _state.empty,
          value = _state.value;
      var onBlur = this.props.onBlur;


      if (empty) {
        this.setState({ error: messages.fieldRequired });
      }

      if (onBlur) {
        onBlur(value);
      }
    }
  }, {
    key: 'getElementType',
    value: function getElementType() {
      return 'base';
    }
  }, {
    key: 'getElementOptions',
    value: function getElementOptions() {
      return {};
    }
  }, {
    key: 'mountedAndElementsAvailable',
    value: function mountedAndElementsAvailable() {
      var elements = this.props.elements;


      var element = elements.create(this.getElementType(), (0, _extends3.default)({
        placeholder: ''
      }, this.getElementOptions(), {
        style: {
          base: {
            color: '#18233e',
            fontFamily: '"norms", sans-serif'
          },
          invalid: {
            color: '#18233e'
          }
        }
      }));

      element.mount(this.domNode);

      element.on('change', this.onChange.bind(this));
      element.on('blur', this.onBlur.bind(this));

      if (this.props.elementRef) {
        this.props.elementRef(element);
      }

      this.element = element;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      if (!this.props.elements) {
        return false;
      }

      var _state2 = this.state,
          error = _state2.error,
          complete = _state2.complete;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('input', {
              'form__input--valid': complete,
              'form__input--error': !!error
            })
          },
          _react2.default.createElement('span', { ref: function ref(el) {
              return _this.domNode = el;
            } })
        ),
        error && _react2.default.createElement(
          'div',
          { className: 'error__text text--sm mt-' },
          _react2.default.createElement(_LocalizableMessage.LocalizableMessage, { message: error.message || error })
        )
      );
    }
  }]);
  return StripeElement;
}(_react2.default.PureComponent);

StripeElement.propTypes = {
  elements: _propTypes2.default.object,
  elementRef: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onBlur: _propTypes2.default.func
};

var CardNumberElement = exports.CardNumberElement = function (_StripeElement) {
  (0, _inherits3.default)(CardNumberElement, _StripeElement);

  function CardNumberElement() {
    var _ref2;

    (0, _classCallCheck3.default)(this, CardNumberElement);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var _this4 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = CardNumberElement.__proto__ || (0, _getPrototypeOf2.default)(CardNumberElement)).call.apply(_ref2, [this].concat(args)));

    _this4.CARD_BRANDS = ['visa', 'mastercard', 'americanexpress', 'discover'];

    _this4.handleClick = _this4.handleClick.bind(_this4);
    return _this4;
  }

  (0, _createClass3.default)(CardNumberElement, [{
    key: 'getElementType',
    value: function getElementType() {
      return 'cardNumber';
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      if (this.domNode) {
        // We're proxying any clicks on the root element to the
        // Stripe element reference, so that we focus the input
        // properly even if a user clicks the cc icon.
        this.domNode.click();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _this2 = this;

      if (!this.props.elements) {
        return false;
      }

      var _state3 = this.state,
          brand = _state3.brand,
          error = _state3.error,
          complete = _state3.complete;


      return _react2.default.createElement(
        'div',
        { className: 'form__cc', onClick: this.handleClick },
        _react2.default.createElement('span', { className: (0, _classnames2.default)('form__cc__type', (_classNames = {}, (0, _defineProperty3.default)(_classNames, 'form__cc__type--' + brand, this.CARD_BRANDS.includes(brand)), (0, _defineProperty3.default)(_classNames, 'form__cc__type--unknown', !this.CARD_BRANDS.includes(brand)), _classNames))
        }),
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('input form__cc__input', {
              'form__input--valid': complete,
              'form__input--error': !!error
            })
          },
          _react2.default.createElement('span', { ref: function ref(el) {
              return _this2.domNode = el;
            } })
        ),
        error && _react2.default.createElement(
          'div',
          { className: 'error__text text--sm mt-' },
          _react2.default.createElement(_LocalizableMessage.LocalizableMessage, { message: error.message || error })
        )
      );
    }
  }]);
  return CardNumberElement;
}(StripeElement);

var CardExpiryElement = exports.CardExpiryElement = function (_StripeElement2) {
  (0, _inherits3.default)(CardExpiryElement, _StripeElement2);

  function CardExpiryElement() {
    (0, _classCallCheck3.default)(this, CardExpiryElement);
    return (0, _possibleConstructorReturn3.default)(this, (CardExpiryElement.__proto__ || (0, _getPrototypeOf2.default)(CardExpiryElement)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardExpiryElement, [{
    key: 'getElementType',
    value: function getElementType() {
      return 'cardExpiry';
    }
  }, {
    key: 'getElementOptions',
    value: function getElementOptions() {
      return { placeholder: 'MM / YY' };
    }
  }]);
  return CardExpiryElement;
}(StripeElement);

var CardCVCElement = exports.CardCVCElement = function (_StripeElement3) {
  (0, _inherits3.default)(CardCVCElement, _StripeElement3);

  function CardCVCElement() {
    (0, _classCallCheck3.default)(this, CardCVCElement);
    return (0, _possibleConstructorReturn3.default)(this, (CardCVCElement.__proto__ || (0, _getPrototypeOf2.default)(CardCVCElement)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardCVCElement, [{
    key: 'getElementType',
    value: function getElementType() {
      return 'cardCvc';
    }
  }]);
  return CardCVCElement;
}(StripeElement);

var IbanElement = exports.IbanElement = function (_StripeElement4) {
  (0, _inherits3.default)(IbanElement, _StripeElement4);

  function IbanElement() {
    (0, _classCallCheck3.default)(this, IbanElement);
    return (0, _possibleConstructorReturn3.default)(this, (IbanElement.__proto__ || (0, _getPrototypeOf2.default)(IbanElement)).apply(this, arguments));
  }

  (0, _createClass3.default)(IbanElement, [{
    key: 'getElementType',
    value: function getElementType() {
      return 'iban';
    }
  }, {
    key: 'getElementOptions',
    value: function getElementOptions() {
      return {
        supportedCountries: ['SEPA']
      };
    }
  }]);
  return IbanElement;
}(StripeElement);

var PostalCodeElement = exports.PostalCodeElement = function (_StripeElement5) {
  (0, _inherits3.default)(PostalCodeElement, _StripeElement5);

  function PostalCodeElement() {
    (0, _classCallCheck3.default)(this, PostalCodeElement);
    return (0, _possibleConstructorReturn3.default)(this, (PostalCodeElement.__proto__ || (0, _getPrototypeOf2.default)(PostalCodeElement)).apply(this, arguments));
  }

  (0, _createClass3.default)(PostalCodeElement, [{
    key: 'getElementType',
    value: function getElementType() {
      return 'postalCode';
    }
  }]);
  return PostalCodeElement;
}(StripeElement);